/* eslint-disable max-len */
/**
 * French translations.
 */
export default {
  ACTION: {
    CANCEL: 'Annuler',
    CONFIRM: 'Confirmer',
    SAVE: 'Sauvegarder',
    SEARCH: 'Rechercher'
  },
  ERROR: {},
  HEADER: {
    EMAIL: 'E-mail',
    END_DATE: 'Date de fin',
    MEMBER_ID: 'Membre ID',
    NAME: 'Nom'
  },
  LABEL: {
    ALLOW_ADD_MEMBERS: 'Autorise l\'ajout de membres',
    CREATE_MEMBER: 'Ajouter un membre',
    DELETE_MEMBER_MODAL_TITLE: 'Supprimer un membre',
    EDIT_MEMBER: 'Modifier un membre',
    EMAIL: 'E-mail',
    END_DATE: 'Date de fin',
    MEMBERS: 'Membres',
    NAME: 'Nom',
    NO: 'Non',
    YES: 'Oui'
  },
  SENTENCE: {
    DELETE_MEMBER_TEXT: 'Es-tu sûr de vouloir supprimer ce membre ?',
    NO_MEMBER_NAME_EMAIL: 'Aucun nom et/ou aucun email',
    NO_MEMBER_NAME_EMAIL_DETAIL: 'Saisis le nom et/ou l\'email',
    NO_ROWS_MEMBERS: 'Aucun membre',
    NO_ROWS_MEMBERS_DESCRIPTION: 'Modifie les critères de recherche'
  },
  SUCCESS: {
    MEMBER_DELETED: 'Membre supprimé avec succès',
    MEMBER_DETAILS_SAVED: 'Membre ajouté avec succès',
    SUCCESS: 'Succès'
  },
  TOOLTIP: {
    EDIT_MEMBER: 'Modifier un membre',
    EMAIL: 'E-mail',
    END_DATE: 'Date de fin',
    MEMBER_ID: 'Membre ID',
    NAME: 'Nom',
    REMOVE_MEMBER: 'Supprimer un membre'
  }
};
